<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M2 8C2 7.58579 2.33579 7.25 2.75 7.25L11.4395 7.25L8.71973 4.53027C8.42683 4.23738 8.42683 3.76262 8.71973 3.46973C9.01262 3.17683 9.48738 3.17683 9.78027 3.46973L13.7803 7.46973C14.0732 7.76262 14.0732 8.23738 13.7803 8.53027L9.78027 12.5303C9.48738 12.8232 9.01262 12.8232 8.71973 12.5303C8.42683 12.2374 8.42683 11.7626 8.71973 11.4697L11.4395 8.75L2.75 8.75C2.33579 8.75 2 8.41421 2 8Z"
    fill="currentColor"
  />
</svg>
